import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=4d85101c&scoped=true&"
import script from "./VInput.vue?vue&type=script&lang=ts&"
export * from "./VInput.vue?vue&type=script&lang=ts&"
import style0 from "./VInput.vue?vue&type=style&index=0&id=4d85101c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85101c",
  null
  
)

export default component.exports